module.exports = __webpack_public_path__ + "img/icon_pastorders_mobile.9e783cbb.svg";